<template>
  <div v-if="vars.titleHtml" v-html="vars.titleHtml" class="tw-z-50 tw-mb-10 tw-flex tw-justify-center" />

  <section v-if="variants.v1 === variant" class="relative tw-h-[80vh]">
    <video
      ref="bgVideo"
      v-if="isMobileDevice && vars.mobileBackgroundVideo"
      :src="vars.mobileBackgroundVideo"
      class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-object-cover"
      playsinline
      @click="togglePlay"
    ></video>

    <video
      ref="bgVideo"
      v-else-if="vars.backgroundVideo"
      :src="vars.backgroundVideo"
      class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-object-contain"
      playsinline
      @click="togglePlay"
    ></video>

    <div
      v-if="!isPlaying"
      @click="togglePlay"
      class="absolute inset-0 flex items-center justify-center cursor-pointer z-50"
    >
      <svg width="140" height="140" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="70" cy="70" r="70" fill="white" />
        <path
          d="M78.7631 70.5L65.6031 78.732L64.2031 79.6V61.4L78.7631 70.5ZM76.1031 70.5L65.6031 63.92V77.08L76.1031 70.5Z"
          fill="var(--c-primary)"
        />
      </svg>
    </div>
  </section>

  <!-- VARIANT 2 -->

  <section v-if="variants.v2 === variant" class="tw-relative tw-h-[80vh] tw-w-full">
    <!-- Video arka planı: autoplay, muted, loop -->
    <video
      ref="bgVideo"
      v-if="isMobileDevice && vars.mobileBackgroundVideo"
      :src="vars.mobileBackgroundVideo"
      class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-cover"
      autoplay
      muted
      loop
      playsinline
    ></video>
    <video
      ref="bgVideo"
      v-else-if="vars.backgroundVideo"
      :src="vars.backgroundVideo"
      class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-cover"
      autoplay
      muted
      loop
      playsinline
    ></video>

    <div class="tw-absolute tw-inset-0 tw-z-50 tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center">
      <!-- Başlık -->
      <h2 class="tw-max-w-4xl tw-text-white">
        {{ vars.titleText }}
      </h2>
      <!-- Açıklama -->
      <p class="tw-mt-12 tw-max-w-4xl tw-text-white">
        {{ vars.descriptionText }}
      </p>
      <!-- Link butonları -->
      <div v-if="buttons" class="tw-mt-12 tw-flex tw-flex-wrap tw-gap-6">
        <nuxt-link
          v-for="(button, idx) in buttons"
          :key="`btn-${idx}`"
          :to="button.link"
          :class="[
            'tw-inline-flex tw-items-center tw-gap-2 tw-rounded-lg tw-px-6 tw-py-3 tw-font-semibold tw-transition-all tw-duration-300',
            buttons.length > 1 ? 'tw-w-full md:tw-w-auto' : 'tw-w-auto',
            `n-${button.type}`,
          ]"
        >
          {{ button.label }}
        </nuxt-link>
      </div>
    </div>
  </section>

  <section v-if="variants.v3 === variant" class="tw-relative tw-h-[80vh] tw-w-full">
    <!-- Mobil video -->
    <video
      v-if="isMobileDevice && vars.mobileBackgroundVideo"
      :src="vars.mobileBackgroundVideo"
      class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-cover"
      autoplay
      muted
      loop
      playsinline
    ></video>

    <!-- Masaüstü video -->
    <video
      v-else-if="vars.backgroundVideo"
      :src="vars.backgroundVideo"
      class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-cover"
      autoplay
      muted
      loop
      playsinline
    ></video>

    <!-- Fotoğraf -->
    <img
      v-else-if="vars.photoImage"
      :src="vars.photoImage"
      alt="Background"
      class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-cover"
    />

    <!-- İçerik -->
    <div class="tw-absolute tw-inset-0 tw-z-50 tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center">
      <h2 class="tw-max-w-4xl tw-text-white">
        {{ vars.titleText }}
      </h2>
      <p class="tw-mt-12 tw-max-w-4xl tw-text-white">
        {{ vars.descriptionText }}
      </p>
      <div v-if="buttons" class="tw-mt-12 tw-flex tw-flex-wrap tw-gap-6">
        <nuxt-link
          v-for="(button, idx) in buttons"
          :key="`btn-${idx}`"
          :to="button.link"
          :class="[
            'tw-inline-flex tw-items-center tw-gap-2 tw-rounded-lg tw-px-6 tw-py-3 tw-font-semibold tw-transition-all tw-duration-300',
            buttons.length > 1 ? 'tw-w-full md:tw-w-auto' : 'tw-w-auto',
            `n-${button.type}`,
          ]"
        >
          {{ button.label }}
        </nuxt-link>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineNuxtComponent } from '#app';
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'SingleVideo',
  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
      },
      isPlaying: false as boolean,
    };
  },

  computed: {
    descriptions() {
      return this.groupedVariables.descriptions;
    },
    cards() {
      return this.groupedVariables.cards;
    },
    buttons() {
      return this.groupedVariables.buttons;
    },
  },
  methods: {
    togglePlay() {
      const vid = this.$refs.bgVideo as HTMLVideoElement | undefined;
      if (!vid) return;

      if (vid.paused) {
        vid.play();
        this.isPlaying = true;
      } else {
        vid.pause();
        this.isPlaying = false;
      }
    },
  },
});
</script>
